import { getStatus, type ApplicationStatusResource } from "@carnet/api/backoffice";

const STATUS_TIMEOUT_MS = 4000;

function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return Promise.race([promise, new Promise<T>((_, reject) => setTimeout(() => reject(new Error("app-status timeout")), ms))]);
}

export function useAppStatus() {
  const status = useState<ApplicationStatusResource | null>("app-status", () => null);
  const dialogOpen = useState<boolean>("app-status-dialog", () => false);

  const isBlocking = computed(() => status.value?.isBlocking === true);
  const message = computed(() => status.value?.message ?? "");

  const check = async (clientApplication: string, locale: string) => {
    try {
      const response = (await withTimeout(
        getStatus({ composable: "$fetch", headers: { "X-Client-Application": clientApplication }, path: { locale } }),
        STATUS_TIMEOUT_MS
      )) as { data?: ApplicationStatusResource } | undefined;
      status.value = response?.data ?? null;
    } catch {
      status.value = null;
    }
    dialogOpen.value = status.value !== null && !status.value.isBlocking;
    return status.value;
  };

  return { status, isBlocking, message, dialogOpen, check };
}
